<template>
  <div v-if="enable">
    <CalculatorHome v-if="isCalculatorApplicant && !isUserSecondaryApplicant" />
    <Home v-else-if="!isUserSecondaryApplicant && !isCalculatorApplicant" />
    <HomeSecondary v-else />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Home from './Home.vue';
import HomeSecondary from './HomeSecondary.vue';
import CalculatorHome from '../CalculatorAuth/Home/Home';
import appConfig from '../../utils/app-config';

export default {
  name: 'HomeIndex',
  components: { Home, HomeSecondary, CalculatorHome },
  computed: {
    ...mapGetters({
      isUserSecondaryApplicant: 'vehicleApplication/isUserSecondaryApplicant',
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    ...mapState({ user: (state) => state.auth.user }),
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    }
  },
  created() {
    var subDomain = this.forLocalDomainConversion(window.location.hostname);
    var userSubDomain = 'default';

    if (this.user && this.user.whiteLabel && this.user.whiteLabel.enableWhiteLabel) userSubDomain = this.user.whiteLabel.domains[0];

    if (subDomain != userSubDomain && subDomain != 'localhost') {
      if (userSubDomain === 'default' && (subDomain === this.au_DEFAULT_DOMAIN || subDomain === this.nz_DEFAULT_DOMAIN)) this.enable = true;
      else this.enable = true;
      // else window.location.href = location.protocol + '//' + window.location.host + '/logout';
    } else this.enable = true;
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data: function () {
    return {
      enable: false,
      au_DEFAULT_DOMAIN: appConfig.VUE_APP_AU_DEFAULT_DOMAIN ? appConfig.VUE_APP_AU_DEFAULT_DOMAIN : 'fleetpartners-dev.eclipx.xyz',
      nz_DEFAULT_DOMAIN: appConfig.VUE_APP_NZ_DEFAULT_DOMAIN ? appConfig.VUE_APP_NZ_DEFAULT_DOMAIN : 'test10-fleetpartners-dev.eclipx.xyz'
    };
  },
  methods: {
    forLocalDomainConversion: function (domain) {
      return domain.replace('.localhost', '.eclipx.xyz');
    }
  }
};
</script>
